const doResize = function(event) {
    if(window.innerWidth < window.innerHeight && window.innerWidth < 1000) {
        // portrait
        const instructions = document.querySelector('.js-instructions');
        instructions.classList.remove('hidden');
    } else {
        // landscape
        const instructions = document.querySelector('.js-instructions');
        instructions.classList.add('hidden');
    };
};

window.addEventListener('resize', doResize, true);

doResize();

